export default function getConfig(){
  
    const config = {
        width: "540px",
        height: "450px",
        floating: true,
        hideBotAvatar: true,
        hideUserAvatar: true,
        headerTitle: "Welcome to MediCard Customer Support!",
        placeholder: "Type your message here",
        botDelay: 500,
        userDelay: 500,
        enableSmoothScroll: true,
        floatingStyle:{
          height:"85px",
          width:"85px",
          display:"none",
          transform: "scaleX(-1)",
          background :"linear-gradient(305deg, rgba(54,72,172,1) 25%, rgba(128,0,128,1) 80%",
        },
        bubbleStyle:{
          maxWidth: "450px",
          marginLeft:"20px"
        },
        submitButtonStyle: {
          position:"absolute",
            background: "linear-gradient(0deg, rgba(54,72,172,1) 0%, rgba(128,0,128,1) 100%)",
            borderRadius: "30px",
            color: "white",
            fill: "white",
            width: "50px",
            height: "50px",
            transform: "scale(0.75)",
        },
        bubbleOptionStyle:{
          background: "#800080",
          color:"white",
          display:"block",
          minWidth:"200px",
          maxWidth:"400px",
          marginLeft: "20px"
        },
      };
    return config;
}